 export class TemplateSyncModel {
    outcomeCounts: number;
    assessmentCounts: number;
    resultCounts: number;

    constructor() {
        this.outcomeCounts = 0;
        this.assessmentCounts = 0;
        this.resultCounts = 0;
    }
}




/** WEBPACK FOOTER **
 ** ./app/templatemgt/models/TemplateSyncModel.ts
 **/